import React from 'react';
import { Navigate } from 'react-router-dom';
import { isAuthenticated } from '../services/auth';

/**
 * 私有路由组件 - 需要登录才能访问
 * @param {object} props
 * @param {React.ReactNode} props.children 子组件
 * @returns {React.ReactNode}
 */
const PrivateRoute = ({ children }) => {
  return isAuthenticated() ? children : <Navigate to="/login" replace />;
};

export default PrivateRoute;
